import React from 'react';
import { is } from '../../services/index';
import { hashClass } from '../../helpers';
import clsx from 'clsx';
import { useTrilogyContext } from '../../context';
/**
 * Navbar component
 * @param children {React.ReactNode} Navbar child
 * @param className {string} Additionnal css classes
 * @param newNavbar {boolean} Display new header
 * @param npmNavbar {boolean} Display old header
 */
const Navbar = ({ children, className, newNavbar, npmNavbar, testId, accessibilityLabel = 'main navigation', ...others }) => {
    const { styled } = useTrilogyContext();
    const classes = hashClass(styled, clsx('navbar', newNavbar && !npmNavbar && is('new'), npmNavbar && !newNavbar && is('npm'), className));
    return (React.createElement("div", { "aria-label": accessibilityLabel, "data-testid": testId, role: 'navigation', className: classes, ...others }, children));
};
export default Navbar;
//# sourceMappingURL=Navbar.js.map